// Shared error + not-found boundaries for TanStack routes with loaders.
// Keeps SSR errors visible without leaking stack traces.
import { useRouter, Link } from "@tanstack/react-router";
import { useEffect } from "react";
// P5 — Sentry importado dinamicamente para não vazar 70KB no bundle principal.

export function RouteErrorBoundary({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const router = useRouter();
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error(error);
    void import("@sentry/react").then((Sentry) => Sentry.captureException(error));
  }, [error]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-semibold">Algo salió mal</h1>
        <p className="text-muted-foreground">
          Ocurrió un error al cargar esta página. Intenta de nuevo en unos segundos.
        </p>
        <div className="flex gap-2 justify-center">
          <button
            onClick={() => {
              router.invalidate();
              reset();
            }}
            className="inline-flex h-10 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground"
          >
            Reintentar
          </button>
          <Link
            to="/"
            className="inline-flex h-10 items-center rounded-md border px-4 text-sm font-medium"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}

export function RouteNotFoundBoundary({ message }: { message?: string }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-semibold">No encontramos esta página</h1>
        <p className="text-muted-foreground">
          {message ?? "El recurso solicitado ya no está disponible."}
        </p>
        <Link
          to="/"
          className="inline-flex h-10 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground"
        >
          Ir al inicio
        </Link>
      </div>
    </div>
  );
}
